import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import arrow from "./../../../Images/GreenDesignArrow.png";
// import ReadMore from "../../CommonUI/ReadMoreBtn/ReadMore";
import "./Founder.css";
function Founder() {
  return (
    <>
      <section className="meet-founders">
        <Container>
          <div className="meetfounders_main">
          <Row>
              <Col md={12}>
                <h3>Meet the Founders</h3>
                <img
                  className="img-fluid arrow-img"
                  src={arrow}
                  alt="arrow-img"
                />
              </Col>
            </Row>
            <div className="meetfounders_grid">
                <div className="meetfounders_group">
                <Row>
                   <Col md={12} >
                    <div className="each-founder-content">
                      <h4>
                        Mr. J. U. Mansukhani
                        <small>Mentor & Founder</small>
                      </h4>
                      <p>
                        Mr. J. U. Mansukhani, Mentor & Founder of Mansukh Securities & Finance Ltd. He has over 35 years of experience in the financial markets. Besides this he has the honour of serving as an IES officer and an U.N.O. advisor. Moneysukh was founded on the principles of transparency, honesty, and integrity in all our dealings under his visionary leadership.
                      </p>
                      {/* <span>
                        <ReadMore name="Know" />
                      </span> */}
                    </div>
                  </Col>
                </Row>
                </div>
                <div className="meetfounders_group">
                <Row>
                  <Col md={12}>
                    <div className="each-founder-content">
                      <h4>
                        Mr. Virender Mansukhani
                        <small>Founder & CEO</small>
                      </h4>
                      <p>
                        Mr. Virender Mansukhani is the Founder and CEO of "Moneysukh" and holds a Bachelor of Engineering (Computer Science) degree. He has to his credit a rich experience of more than 30 years in the financial markets. For “Moneysukh”, his key strength has been his  meticulous and strategic planning, and he has been a key architect of our growth. His exceptional leadership and outstanding commitment have been an inspiration to the "Moneysukh" workforce and have been instrumental in establishing "Moneysukh" as one of the leading financial services companies.
                      </p>
                      
                    </div>
                  </Col>
                  
                </Row>
                </div>
                <div className="meetfounders_group">
                <Row>
                  
                  <Col md={12}>
                    <div className="each-founder-content">
                      <h4>
                        Mr. Sanjeev Gupta
                        <small>Director</small>
                      </h4>
                      <p>
                        Mr. Sanjeev Gupta is a Fellow member of the Institute of Chartered Accountants of India with over 30 years of experience in the Securities, Commodity, and Currency markets. With his vast experience, in-depth knowledge and passion for passion for stock markets, he assures efficient and flawless operations of the Group. 
                      </p>
                      
                    </div>
                  </Col>
                </Row>
                </div>
               
                <div className="meetfounders_group dedicated_team">
                <Row>
                  <Col>
                    <p>
                       We are proud to say that all our dedicated team members with their customer-centric approach are the most important element in the Moneysukh success story.  
                    </p>
                  </Col>
                </Row>
                </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
}
export default Founder;
